module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin7-134c0b195754754b573253bacc14adcd.jpg";